<h3>Edit Description</h3>
<mat-dialog-content>
    <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <textarea 
                matInput 
                [(ngModel)]="description" 
                rows="20" 
                placeholder="Describe your property (amenities, highlights, rules...)"
                maxlength="10000">
            </textarea>
            <mat-hint align="end">{{ description.length || 0 }}/10000 characters</mat-hint>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="metallic-text-btn-red" type="button" (click)="cancel.emit()"><mat-icon matPrefix>cancel</mat-icon>Canel</button>
    <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="save.emit(description)"><mat-icon matPrefix>save</mat-icon>Save</button>
</mat-dialog-actions>
